import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BankAccount } from 'constants/bank-account.constants';
import { PendingRequestTypes } from 'constants/requests.constants';
import { formValue, intialMessage, userMessage } from 'constants/ui.constants';
import _ from 'lodash';

////TODO: set types for awaitng and open pending perhaps?

interface requestsState {
	loading: boolean;
	message: userMessage;
	all: object;
	awaitingAuth: object;
	openPending: object;
  withdrawalRequests:any[]
}

const initialState: requestsState = {
	loading: false,
	message: intialMessage,
	all: {},
	awaitingAuth: {},
	openPending: {},
  withdrawalRequests:[]
};

export const pendingRequestsSlice = createSlice({
	name: 'pendingRequests',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setAll: (state, action: PayloadAction<object>) => {
			state.all = action.payload;
		},
		setAwaitingAuthorization: (state, action: PayloadAction<object>) => {
			state.awaitingAuth = action.payload;
		},
    setWithdrawalRequests: (state, action: PayloadAction<any[]>) => {
			state.withdrawalRequests = action.payload;
		},

		setAwaitingAuthorizationCategories: (
			state,
			action: PayloadAction<{ list: object[]; category: PendingRequestTypes }>
		) => {
			if (_.has(state?.awaitingAuth, action.payload.category)) {
				_.assign(state.awaitingAuth, { [action.payload.category]: action.payload.list });
			}
		},

		setOpenPendingCategories: (state, action: PayloadAction<{ list: object[]; category: PendingRequestTypes }>) => {
			if (_.has(state?.openPending, action.payload.category)) {
				_.assign(state.openPending, { [action.payload.category]: action.payload.list });
			}
		},

		setOpenPending: (state, action: PayloadAction<object>) => {
			state.openPending = action.payload;
		},
	},
});

export const {
	setLoading,
	setMessage,
	setAll,
	setAwaitingAuthorization,
	setAwaitingAuthorizationCategories,
	setOpenPendingCategories,
	setOpenPending,
  setWithdrawalRequests,
} = pendingRequestsSlice.actions;

export const isLoading = (state: any) => state.pendingRequests.loading;
export const getMessage = (state: any) => state.pendingRequests.message;
export const getAwaitingAuthorization = (state: any) => state.pendingRequests.awaitingAuth;
export const getOpenPendingRequests = (state: any) => state.pendingRequests.openPending;
export const getOpenPendingRequestsPayments = (state: any) => state.pendingRequests.openPending?.paymentRequests || [];
export const getAllRequests = (state: any) => state.pendingRequests.all || [];
export const getPaymentById = (id: string) => (state: any) =>
	_.find(state.pendingRequests.all?.paymentRequests, { id: Number(id) });

export default pendingRequestsSlice.reducer;
